import React, { Component } from 'react'
import { TableRow, MenuItem, Button, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'
import {
  TableCellWithTextField,
  TableCellWithSwitch,
  TableCellWithSelect,
} from '../../../components/common/PureItems'

import EditActionComponent from '../../../components/common/EditActionComponent'

export default class LossReasonListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isUpdateCompleted !== prevProps.isUpdateCompleted &&
      this.props.isUpdateCompleted === true
    ) {
      this.props.disableEdit()
    }
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode } = this.props

    return (
      <TableRow>
        <TableCellWithTextField
          valueToRender={data.description}
          editMode={editMode}
          value={data.description}
          onChange={this.onChange('description')}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
        />
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/LossReasonListItem.js